<template>
    <div class="vld-parent my-3" v-if="View_acce">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
    
        <div class="">
            <div class="container-fluid">
                <div class="row">
                    <!--<CCol md="6">
        <div class="custom-carousel-dahsboard1"
             @touchstart="handleTouchStart"
             @touchmove="handleTouchMove"
             @touchend="handleTouchEnd">
            <ol class="carousel-indicators">
                <li :class="{ active: index === currentSlide }" v-for="(slide, index) in 2"></li>
            </ol>
            <div class="carousel-inner">
                <div v-for="(slide, index) in 2"
                     :key="index"
                     class="carousel-item"
                     :class="{ active: index === currentSlide }">
                    <div class="slide-content w-100" v-if="index == 0" :key="0">
                        <div className="" style="display: grid; grid-template-columns: 33% 33% 33%;margin-top:10px ">
                            <div class="px-0 text-center" @click="copyMemberLink()">
                                <h2 class="theme-value mb-0 text-white">{{formatNumber(D_DailyFirstDeposit,0)}} / {{formatNumber(D_ActiveMember,0)}}</h2>
                                <h6 class="theme-title mb-0" style="color: #ff7500; font-size: .75rem; font-weight: bold;">{{getLanguage["DB"]["AM"]}}</h6>
                            </div>
                            <div class="px-0 text-center">
                                <h2 class="theme-value mb-0 text-white">{{formatNumber(D_Register,0)}}</h2>
                                <h6 class="theme-title mb-0" style="color: #ff7500; font-size: .75rem; font-weight: bold;">{{getLanguage["DB"]["DR"]}}</h6>
                            </div>
                            <div class="px-0 text-center">
                                <h2 class="theme-value mb-0 text-white">{{formatNumber(setMemberOnline,0)}}</h2>
                                <h6 class="theme-title mb-0" style="color: #ff7500; font-size: .75rem; font-weight: bold;">{{getLanguage["DB"]["MO"]}}</h6>
                            </div>
                        </div>
                    </div>
                    <div class="slide-content w-100" v-if="index == 1" :key="1">
                        <div className="" style="display: grid; grid-template-columns: 33% 33% 33%; margin-top: 10px ">
                            <div class="px-0 text-center">
                                <h2 class="theme-value mb-0 text-white">{{formatNumber(setTotalMember,0)}}</h2>
                                <h6 class="theme-title mb-0" style="color: #ff7500; font-size: .75rem; font-weight: bold;">{{getLanguage["DB"]["TM"]}}</h6>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </CCol>-->
                    <CCol md="6">
                        <div class="mb-3" style=" background: rgb(28, 28, 32); padding: 10px; border-radius: .25rem; border: 1px solid rgba(249, 249, 249, 0.28);position:relative" v-if="showFirstTimeRemind">
                            <div class="d-flex align-items-center" style="gap: 20px; color: rgb(255, 255, 255); ">

                                <div class="icon-container">
                                    <i class="fa-solid fa-shield-halved"></i>
                                </div>

                                <div>
                                    First-time Login: Change Your Password !!!<br /><br />

                                    1. Click the <strong>hamburger menu (☰)</strong><br />
                                    2. Select the <strong>Profile icon</strong><br />
                                    3. Enter your new password and click <strong>Save</strong>
                                </div>
                            </div>
                            <i class="fa-solid fa-close" style="color: white;position: absolute;top: 10px;right: 10px;" @click="showFirstTimeRemind ? showFirstTimeRemind = false : showFirstTimeRemind = true"></i>
                        </div>

                        <div class="mb-3" style=" background: rgb(28, 28, 32); padding: 10px; border-radius: .25rem; border: 1px solid rgba(249, 249, 249, 0.28);position:relative">
                            <div class="d-flex" style="gap: 10px; color: rgb(255, 255, 255); ">
                                <div style="width:55%;line-height:15px;">
                                    <div class="d-flex align-items-center" @click="isVisibleBalance ? isVisibleBalance = false : isVisibleBalance = true">
                                        <span class="">
                                            {{this.getLanguage['DB']['TEN']}}
                                            <i class="fa fa-eye ml-2" style=" font-size: 12px;" v-if="isVisibleBalance"></i>
                                            <i class="fa fa-eye-slash ml-2" style=" font-size: 12px;" v-else></i>
                                        </span><br />
                                    </div>
                                    <h4 class="text-white font-weight-bold mb-0" v-if="isVisibleBalance">{{formatNumber(this.PNLDNM[0].TE, 2, this.getCurrencySymbol)}} </h4>
                                    <h4 class="text-white font-weight-bold mb-0" v-else>********</h4>

                                    <router-link to="/W/WDU" tag="a" class="" style="">
                                        <CButton class='font-weight-bold m-0 mt-2 p-1' color="success"><span>{{this.getLanguage['SMB']['W']}}</span></CButton>
                                    </router-link>
                                </div>

                                <div style="width:45%;line-height:16px;">
                                    <div class="d-flex align-items-center">
                                        <router-link class="text-white" :to="{ path:'/EARN/D', query:{ t: 3 }}" tag="a">
                                            {{this.getLanguage['DB']['DL']}} {{this.getLanguage['DB']['RARN']}}
                                            <i class="fa fa-plus-square text-white ml-2"></i>
                                        </router-link><br />
                                    </div>

                                    <template v-if="isVisibleBalance">
                                        {{ formatNumber(this.PNLDNM[0].DE, 2, this.getCurrencySymbol) }}
                                    </template>
                                    <template v-else>
                                        ********
                                    </template>
                                    <br />
                                    <br />

                                    <div class="d-flex align-items-center">
                                        <router-link class="text-white" :to="{ path:'/EARN/M', query:{ t: 3 }}" tag="a">
                                            {{this.getLanguage['SMB']['M']}} {{this.getLanguage['DB']['RARN']}}
                                            <i class="fa fa-plus-square text-white ml-2"></i>
                                        </router-link><br />
                                    </div>
                                    <template v-if="isVisibleBalance">
                                        {{ formatNumber(this.PNLDNM[0].ME, 2, this.getCurrencySymbol) }}
                                    </template>
                                    <template v-else>
                                        ********
                                    </template>
                                </div>
                            </div>
                            <i class="fa-solid fa-up-right-and-down-left-from-center" v-if="!showMoreBalanceInfo" @click="showMoreBalanceInfo ? showMoreBalanceInfo = false : showMoreBalanceInfo = true"></i>

                            <div :class="showMoreBalanceInfo ? 'd-block': 'd-none'">
                                <!--<apexchart ref="apexchart" class="" height="300px" width="100%" type="area" :options="chartOptions" :series="series"></apexchart>-->
                                <apexchart ref="apexchart" class="" height="auto" width="100%" type="area" :options="chartOptions" :series="series"></apexchart>
                                <div class="text-white text-left day-list mb-3"> <span :class="chartActiveDuration == 7 ? 'durationActive pointer' : 'durationNoActive pointer'" @click="showChartDuration(7)">{{this.getLanguage["PM"]["PAST"]}} 7 {{this.getLanguage["MEM"]["DDAY"]}}</span> <span :class="chartActiveDuration == 15 ? 'durationActive pointer' : 'durationNoActive pointer'" @click="showChartDuration(15)">{{this.getLanguage["PM"]["PAST"]}} 15 {{this.getLanguage["MEM"]["DDAY"]}}</span> <span :class="chartActiveDuration == 30 ? 'durationActive pointer' : 'durationNoActive pointer'" @click="showChartDuration(30)">{{this.getLanguage["PM"]["PAST"]}} 30 {{this.getLanguage["MEM"]["DDAY"]}}</span> </div>

                                <div class="text-white text-center mt-2">
                                    <i class="fa fa-chevron-up" v-if="showMoreBalanceInfo" @click="showMoreBalanceInfo ? showMoreBalanceInfo = false : showMoreBalanceInfo = true"></i>
                                </div>
                            </div>
                        </div>

                        <div class="memberInfoBox mb-3" v-if="PNLSummaryArray30 && PNLSummaryArray30.length > 0 && PNLSummaryArray30[0].WLA > 0">
                            <img class="img-fluid coin" width="50" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/ggearn/coin.svg">
                            <div class="memberInfoBox-data mb-1">
                                <span v-html='String.format(this.getLanguage["GGE"]["ITEM0"], formatNumber(PNLSummaryArray30[0].WLA,2, this.getCurrencySymbol))'></span>
                            </div>
                            <div class="d-flex align-items-center position-relative" style="gap:15px">
                                <div class="memberInfoBox-icon">
                                    <i class="fa fa-usd" aria-hidden="true" style="font-size: 30px; color: rgb(255, 255, 255);  "></i>
                                </div>
                                <p class="text-white mb-0">{{getLanguage["GGE"]["DESC0"]}}</p>
                            </div>
                        </div>

                        <div class="memberInfoBox mb-3">
                            <img class="img-fluid coin" width="50" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/ggearn/coin.svg">
                            <div class="memberInfoBox-data mb-1">
                                <span v-html='String.format(this.getLanguage["GGE"]["ITEM1"], formatNumber(D_DailyFirstDeposit,0), formatNumber(D_ActiveMember,0))'></span>
                            </div>
                            <div class="d-flex align-items-center position-relative" style="gap:15px">
                                <div class="memberInfoBox-icon">
                                    <img class="img-fluid" width="20" src="../../src/assets/icons/icon-deposit-member.svg">
                                </div>
                                <p class="text-white mb-0">{{getLanguage["GGE"]["DESC1"]}}</p>
                            </div>
                        </div>

                        <div class="memberInfoBox mb-3">
                            <img class="img-fluid coin" width="50" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/ggearn/coin.svg">
                            <div class="memberInfoBox-data mb-1">
                                <span v-html='String.format(this.getLanguage["GGE"]["ITEM2"], formatNumber(D_Register,0))'></span>
                            </div>
                            <div class="d-flex align-items-center position-relative" style="gap:15px">
                                <div class="memberInfoBox-icon">
                                    <img class="img-fluid" width="20" src="../../src/assets/icons/icon-reg-user.svg">
                                </div>
                                <p class="text-white mb-0">{{getLanguage["GGE"]["DESC2"]}}</p>
                            </div>
                        </div>

                        <div class="memberInfoBox mb-3">
                            <img class="img-fluid coin" width="50" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/ggearn/coin.svg">
                            <div class="memberInfoBox-data mb-1">
                                <span v-html='String.format(this.getLanguage["GGE"]["ITEM3"], formatNumber(setMemberOnline,0))'></span>
                            </div>
                            <div class="d-flex align-items-center position-relative" style="gap:15px">
                                <div class="memberInfoBox-icon">
                                    <img class="img-fluid" width="20" src="../../src/assets/icons/icon-member-online.svg">
                                </div>
                                <p class="text-white mb-0">{{getLanguage["GGE"]["DESC3"]}}</p>
                            </div>
                        </div>
                    </CCol>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import genericHelper from "../modules/GenericHelper.js";
    import moment from 'moment'
    import Loading from 'vue-loading-overlay';
    import { constRejectReasonP, constRejectReasonD, constRejectReasonW, constAccessType, loadingFullScreen } from '@/modules/Constant.js'
    import DateRangePicker from 'vue2-daterange-picker'
    import Treeselect from '@riophae/vue-treeselect'
    import { customtreeselect } from '@/views/CustomControl/index.js'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import VueApexCharts from 'vue-apexcharts'
    import Vue from 'vue'
    import $ from 'jquery'

    Vue.use(VueApexCharts)
    Vue.component('apexchart', VueApexCharts)

    export default {
        props: ['arry_san_length'],
        mixins: [genericHelper],
        computed: {
            ...mapGetters('UserInfo', ['getUserInfo', 'checkModuleAccess', 'checkModuleIndex']),
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('DashboardData', [
                'getPendingDeposit',
                'getPendingWithdrawal',
                'getPendingPromotion'
            ]),
            ...mapGetters('SMBData', [
                'getCurrencySymbol',
                'getSystemBalance',
                'getCreditBalance',
                'getBalanceStatus',
                'getCurrencyCode'
            ]),
        },
        name: 'DashboardMonitoring',
        components: {
            Loading,
            Treeselect,
            customtreeselect,
            DateRangePicker
        },
        data() {
            return {
                bool_fullLoading: false, //Loading Visible
                bool_fullScreen: loadingFullScreen, //Full Screen
                bool_isSort: false,
                bool_firstLogin: false,
                bool_firstsearchAgent: false,
                dd_agentgroup: [],//agent group option
                dd_subagentgroup: [],//subagent group option
                ddDefaultSubBrand: [],//subagent default group option
                dd_currency: [],
                dd_currency1: [],
                obj_details: {},
                arry_details: [],
                SummaryArray: [],
                PNLDNM: {
                    TE: 0,
                    ME: 0,
                    DE: 0
                },
                PNLSummaryArray3: [],
                PNLSummaryArray7: [],
                PNLSummaryArray15: [],
                PNLSummaryArray30: [],
                searchAgent: null,
                searchSubAgent: null,
                searchCurrency: null,
                convertCurrency: null,
                setMemberOnline: 0,
                setMemberOnline_DESKTOP: 0,
                setMemberOnline_MOBILE: 0,
                setMemberOnline_ANDROID: 0,
                setMemberOnline_IOS: 0,
                setMemberOnline_API: 0,
                setTotalMember: 0,
                array_monthlyRS: [],
                array_dailyRS: [],
                AutoGetUpdateTO: null,
                AutoUpdateTO: null,
                rtSubBrand: 0,//subagent dd refresh key

                MTD_Deposit: 0, // Month to Date
                L_MTD_Deposit: 0, // Month to Date
                MTD_Withdraw: 0,
                L_MTD_Withdraw: 0,
                MTD_Register: 0,
                L_MTD_Register: 0,
                AMT_MTD_Bonus: 0,
                AMT_MTD_DLS: 0,
                AMT_MTD_AR: 0,
                AMT_MTD_AFF: 0,
                AMT_MTD_TNMT: 0,
                AMT_MTD_MSA: 0,
                AMT_MTD_BonusC: 0,
                AMT_Y_Deposit: 0,
                AMT_Y_Withdraw: 0,

                D_Deposit: 0, // Day
                D_Withdraw: 0,
                D_Register: 0,
                D_DailyFirstDeposit: 0,
                D_ActiveMember: 0,

                //CD_Deposit: [], // Chart
                //CD_Register: [],
                //CD_DepositMoney: [],
                CD_Earning: [], //Chart

                Y_Deposit: 0, // Yesterday
                Y_Withdraw: 0,

                AMT_MTD_Deposit: 0, // Deposit Amount
                AMT_LMTD_Deposit: 0, // Deposit Amount
                AMT_MTD_Withdraw: 0, // Withdraw Amount
                AMT_LMTD_Withdraw: 0, // Withdraw Amount
                AMT_D_Deposit: 0, // Deposit Amount
                AMT_D_Withdraw: 0, // Withdraw Amount
                AMT_D_Bonus: 0,//Bonus
                AMT_D_AR: 0,//Auto Rebate
                AMT_D_DLS: 0,//Daily Lucky Spin
                AMT_D_Aff: 0,//Affiliate
                AMT_D_TNMT: 0,//Tournament
                AMT_D_MSA: 0,//Prize Drop
                AMT_Y_Bonus: 0,
                AMT_D_PNL: 0, // Day P & L Amount
                AMT_Y_PNL: 0, // Yesterday P & L Amount
                AMT_MTD_PNL: 0, // Month to Date P & L Amount
                AMT_LMTD_PNL: 0, // Last Month to Date P & L Amount
                AMT_LMTD_NPNL: 0, // Last Month to Date Net P & L Amount

                DB_Month: "",
                DB_TDay: "",
                DB_CDay: "",
                DB_DProgress: "",
                DB_DRefresh: "-",

                CurrencySymbol: "",
                View_acce: false,
                top3b: [],
                bottom3b: [],
                chartOptions: {
                    colors: ['#ffa700', '#FFFFFF', '#ff1919'],
                    //colors: ['#30878E', '#6D6BA3', '#f0ab4a'],
                    //stroke: {
                    //    width: 2,
                    //},
                    chart: {
                        width: '105%',
                        offsetX: -15,
                        //foreColor: '#fff',
                        //background: '#000',
                        toolbar: {
                            show: false,
                            tools: {
                                //download: false,
                                //selection: false,
                                //zoom: false,
                                //zoomin: false,
                                //zoomout: false,
                                //pan: false,
                                //reset: false | '<img src="/static/icons/reset.png" width="20">',
                            },
                        },
                    },
                    grid: {
                        borderColor: '#565656',
                        strokeDashArray: 3,
                        //yaxis: {
                        //    lines: {
                        //        show: false
                        //    }
                        //},  
                    },
                    xaxis: {
                        categories: [],
                        type: 'category',
                        tickPlacement: 'on',
                        labels: {
                            show: true,
                            hideOverlappingLabels: false,
                            style: {
                                colors: '#fff',
                                fontSize: '12px',
                            }

                        },
                        //axisBorder: {
                        //    show: true,
                        //    color: '#565656',
                        //    height: 1,
                        //    width: '100%',
                        //    offsetX: 0,
                        //    offsetY: 0
                        //},
                    },
                    yaxis: {
                        labels: {
                            //offsetY: -15,
                            style: {
                                colors: '#fff',
                            },
                            formatter: function (value) {
                                if (value > 0) {
                                    //var val = Math.abs(value)
                                    var val = value
                                    if (val >= 1000) {
                                        //val = (val / 1000).toFixed(1) + ' K'
                                        val = (val / 1000) + ' K'
                                    }
                                } else if (value < 0) {
                                    //var val = Math.abs(value)
                                    var val = value
                                    //val = val * -1
                                    if (val <= -1000) {
                                        //val = (val / 1000).toFixed(1) + ' K'
                                        val = (val / 1000) + ' K'
                                    }
                                } else {
                                    val = value
                                }
                                return val
                            }
                        },
                       // title: {
                            //text: undefined,
                            //rotate: -90,
                           // margin: 0,
                            //offsetX: 0,
                            //offsetX: -20,
                            //style: {
                            //    color: '#565656',
                            //    fontSize: '12px',
                            //    fontFamily: 'Helvetica, Arial, sans-serif',
                            //    fontWeight: 600,
                            //    cssClass: 'apexcharts-yaxis-title',
                            //},
                        //},
                    },
                    markers: {
                        size: 0,
                        style: 'hollow',
                    },
                    dataLabels: {
                        enabled: false,
                        formatter: function (value, { seriesIndex, dataPointIndex, w }) {
                            return value.toLocaleString('en-US', { minimumFractionDigits: 0 })
                        },
                        style: {
                            fontSize: '12px',
                        }
                    },
                    //savedata: [
                    //    {
                    //        name: "Deposit-Money",
                    //        data: []
                    //    },
                    //],
                    tooltip: {
                        custom: function ({ series, seriesIndex, dataPointIndex, w }) {                          
                            if (seriesIndex == 0) {
                                return (
                                    '<div class="apextooltip_box text-left p-2">' +          
                                    '<span>' +
                                    'Earning' +
                                    ': ' +
                                    series[seriesIndex][dataPointIndex].toLocaleString('en-US', { minimumFractionDigits: 0 }) +
                                    '</span>' +
                                    '</div>'
                                )
                            }
                        }
                    },
                    plotOptions: {
                        //bar: {
                        //    dataLabels: {
                        //        orientation: 'vertical',
                        //        position: 'center' // bottom/center/top
                        //    }
                        //}
                        area: {
                            fillTo: 'origin',
                        }
                    },
                    stroke: {
                        width: 1,
                        curve: 'smooth',
                    },
                    legend: {
                        labels: {
                            colors: '#565656',
                        },
                    }
                },
                series: [
                    {
                        name: "Earning",
                        //type: 'column',
                        data: []                      
                    },
                    //{

                    //    name: "Registered",
                    //    //type: 'column',
                    //    data: []
                    //}
                ],
                bool_ajaxloading: {
                    dashboardDataList: false
                },
                fromCache: false,
                dataFromCache: false,
                alreadyLoad: false,
                prevCurrencyCode: null,

                chartActiveDuration: 7,
                isVisibleBalance: false,
                showMoreBalanceInfo: true,
                showFirstTimeRemind: false,

                currentSlide: 0,
                startX: 0,
                endX: 0,
                startTime: 0,
                threshold: 50, // Minimum distance to consider a swipe
                timeThreshold: 800,// Maximum time in milliseconds for a swipe
                isSwiping: false, // Track if a swipe is in progress

                //obj_P: {},
            }
        },
        methods: {
            getAgentGroup() {
                var that = this;
                this.getDataApi(`/api/dd/ag/1/0/1`,
                    function (d, s) {
                        if (s) {
                            that.dd_agentgroup = that.deepClone(d.dropdownlist);

                            if (that.dd_agentgroup.length > 0) {
                                that.dd_agentgroup.forEach(that.disableAgentGroupParent);
                                var at = 0;
                                at = that.dd_agentgroup[0].id.split("-")[0];
                                if (at == 3 && that.dd_agentgroup.length < 2) {
                                    that.searchAgent = that.dd_agentgroup[0].id;
                                }
                            }
                        }
                    });
            },
            disableAgentGroupParent(item, index) {
                var agi = item.id.split("-");
                if (agi[0] != "3") {
                    item.isDisabled = true;
                }

                if (item.children && item.children.length > 0) {
                    item.children.forEach(this.disableAgentGroupParent);
                }


            },
            format_date(value) {
                if (value) {
                    return moment(String(value)).format('DD MMM YYYY')
                }
            },
            AgentGroupChangefs(value) {

                if (value != undefined) {
                    var agi = 0;

                    if (value != "") {
                        agi = value.split("-")[1];
                        this.searchPAgi = agi;
                    } else {
                        this.searchPAgi = 0;
                    }

                } else {
                    this.searchPAgi = 0;
                    this.searchAgent = null;
                }
                this.searchCurrency = null;
                this.dd_currency = null;
                this.getCurrencyList();
            },
            loadSubBrandOptions({ action, searchQuery, callback }) {
                var that = this;
                var parentAGI = 0;
                if (this.searchAgent && this.searchAgent != 'dummy') {
                    var agentList = this.searchAgent.split("-");
                    parentAGI = agentList[agentList.length - 1];
                }

                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    that.dd_subagentgroup = [];
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    searchQuery = encodeURIComponent(searchQuery);
                    this.getDataApi(`/api/dd/subbrand/0/${searchQuery}/${parentAGI}/0/1`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.dd_subagentgroup = d.dropdownlist;
                                //that.bool_cacheOptionValue = true;
                            }
                            else {
                                that.dd_subagentgroup = [];
                            }
                            callback(null, that.dd_subagentgroup);
                        });
                }
            },
            loadDefaultSubBrand(agi) {
                var that = this;
                var searchQuery = "0";

                this.getDataApi(`/api/dd/subbrand/0/${searchQuery}/${agi}/0/1`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddDefaultSubBrand = d.dropdownlist;
                            that.searchSubAgent = that.ddDefaultSubBrand[0].id;
                            that.rtSubBrand = that.rtSubBrand == 0 ? 1 : 0;
                        }
                        else {
                            that.ddDefaultSubBrand = [];
                        }
                    });
            },

            getdashboardData(isHideCount = false, isHideAmount = false) {
                this.bool_ajaxloading.dashboardDataList = true;
                if (isHideCount) {
                    this.D_Register = '-';
                    this.setMemberOnline = '-';
                    this.setMemberOnline_DESKTOP = '-';
                    this.setMemberOnline_MOBILE = '-';
                    this.setMemberOnline_ANDROID = '-';
                    this.setMemberOnline_IOS = '-';
                    this.setMemberOnline_API = '-';
                    this.D_ActiveMember = '-';
                    this.D_DailyFirstDeposit = '-';
                    this.setTotalMember = '-';
                    this.array_monthlyRS = [];
                    this.array_dailyRS = [];
                    this.MTD_Register = '-';
                    this.L_MTD_Register = '-';
                    this.D_Deposit = '-';
                    this.D_Withdraw = '-';
                    this.Y_Withdraw = '-';
                    this.Y_Deposit = '-';
                    this.MTD_Deposit = '-';
                    this.MTD_Withdraw = '-';
                    this.L_MTD_Deposit = '-';
                    this.L_MTD_Withdraw = '-';
                }

                if (isHideAmount) {
                    this.AMT_LMTD_Withdraw = '-';
                    this.AMT_LMTD_Deposit = '-';
                    this.AMT_MTD_Withdraw = '-';
                    this.AMT_D_Deposit = '-';
                    this.AMT_D_Withdraw = '-';
                    this.AMT_Y_Withdraw = '-';
                    this.AMT_Y_Deposit = '-';
                    this.AMT_D_Bonus = '-';
                    this.AMT_D_AR = '-';
                    this.AMT_D_DLS = '-';
                    this.AMT_D_Aff = '-';
                    this.AMT_D_TNMT = '-';
                    this.AMT_D_MSA = '-';
                    this.AMT_MTD_Deposit = '-';
                    this.AMT_Y_Bonus = '-';
                    this.AMT_MTD_Bonus = '-';
                    this.AMT_MTD_AR = '-';
                    this.AMT_MTD_DLS = '-';
                    this.AMT_MTD_AFF = '-';
                    this.AMT_MTD_TNMT = '-';
                    this.AMT_MTD_MSA = '-';
                    this.AMT_MTD_BonusC = '-';
                    this.AMT_D_PNL = '-';
                    this.AMT_Y_PNL = '-';
                    this.AMT_MTD_PNL = '-';
                    this.AMT_LMTD_PNL = '-';
                    this.AMT_LMTD_NPNL = '-';
                }

                var that = this;
                var agi = 0;
                //this.CurrencySymbol = "";

                //If subagent got value, agi = subagent's id, else agent's id
                if (this.searchSubAgent != null) {
                    agi = this.searchSubAgent;
                }
                else {
                    if (this.searchAgent != null)
                        agi = this.searchAgent.split("-")[1];
                }

                var CI = this.searchCurrency;
                //var CTCI = this.convertCurrency;
                var CTCI = this.getCurrencySymbol;
                if (CI != null && CTCI == null) {
                    CTCI = CI;
                }
                let fromCache = that.fromCache == '1' ? 1 : 0;
                var CD = moment().format('YYYY-MM-DD HH:mm:ss');
                var type = 'GGEarn';
                this.getDataApi(`/api/dc/crc?f[CD]=${CD}&f[AGI]=${agi}&f[CI]=${CI}&f[CTCI]=${CTCI}&f[cache]=${fromCache}&f[type]=${type}`,
                    function (d, s) {
                        if (s) {
                            that.bool_ajaxloading.dashboardDataList = false;
                            that.dataFromCache = d.fromCache;
                            that.CurrencySymbol = d.CurrencySymbol;
                            that.D_Register = d.totalDailyRegisteredMember;
                            var totalOnline = 0;
                            var totalOnline_DESKTOP = 0;
                            var totalOnline_MOBILE = 0;
                            var totalOnline_ANDROID = 0;
                            var totalOnline_IOS = 0;
                            var totalOnline_API = 0;

                            for (var i = 0; i < d.totalMemberOnline.length; i++) {
                                totalOnline += d.totalMemberOnline[i].TO;
                                if (d.totalMemberOnline[i].IM == 0) { totalOnline_DESKTOP += d.totalMemberOnline[i].TO; }
                                else if (d.totalMemberOnline[i].IM == 1) { totalOnline_MOBILE += d.totalMemberOnline[i].TO; }
                                else if (d.totalMemberOnline[i].IM == 2) { totalOnline_ANDROID += d.totalMemberOnline[i].TO; }
                                else if (d.totalMemberOnline[i].IM == 3) { totalOnline_IOS += d.totalMemberOnline[i].TO; }
                                else if (d.totalMemberOnline[i].IM == 4) { totalOnline_API += d.totalMemberOnline[i].TO; }
                            }
                            that.top3b = d.Top3B;
                            that.bottom3b = d.Bottom3B;

                            that.setMemberOnline_DESKTOP = totalOnline_DESKTOP;
                            that.setMemberOnline_MOBILE = totalOnline_MOBILE;
                            that.setMemberOnline_ANDROID = totalOnline_ANDROID;
                            that.setMemberOnline_IOS = totalOnline_IOS;
                            that.setMemberOnline_API = totalOnline_API;

                            that.setMemberOnline = totalOnline;

                            that.D_ActiveMember = d.totalActiveMember;
                            that.D_DailyFirstDeposit = d.totalDailyFirstDeposit;
                            that.setTotalMember = d.totalMember;
                            that.array_dailyRS = d.dailyRegisterSource;
                            that.array_monthlyRS = d.MonthlyRegisterSource;
                            that.CD_ActiveMember = d.CD_ActiveMember;
                            //var memtemp = {
                            //    name: "Active Member-Count",
                            //    data: d.CD_Register
                            //}
                            //Vue.set(that.series, 2, memtemp)

                            //that.CD_Register = d.CD_Register;
                            //that.MTD_Register = d.totalMonthlyRegisteredMember;
                            ////The name at the bottom of the chart (Registered-Count)
                            //var regtemp = {
                            //    name: that.getLanguage['DB']['R'],
                            //    data: that.CD_Register
                            //}
                            //Vue.set(that.series, 1, regtemp)

                            that.L_MTD_Register = d.totalLastMonthRegisteredMember;

                            that.SummaryArray = d.getDepositByDay;
                            that.D_Deposit = 0;
                            that.AMT_D_Deposit = 0;
                            var arrL = parseInt(that.SummaryArray.length);
                            var i = 0;
                            for (i = 0; i < arrL; i++) {
                                that.D_Deposit += that.SummaryArray[i].DC;
                                that.AMT_D_Deposit += that.SummaryArray[i].TA;
                            }

                            that.SummaryArray = d.getWithdrawByDay;
                            that.D_Withdraw = 0;
                            that.AMT_D_Withdraw = 0;
                            var arrL = parseInt(that.SummaryArray.length);
                            var i = 0;
                            for (i = 0; i < arrL; i++) {
                                that.D_Withdraw += that.SummaryArray[i].DC;
                                that.AMT_D_Withdraw += that.SummaryArray[i].TA;
                            }

                            that.SummaryArray = d.getDepositByYesterday;
                            that.Y_Deposit = 0;
                            that.AMT_Y_Deposit = 0;
                            var arrL = parseInt(that.SummaryArray.length);
                            var i = 0;
                            for (i = 0; i < arrL; i++) {
                                that.Y_Deposit += that.SummaryArray[i].DC;
                                that.AMT_Y_Deposit += that.SummaryArray[i].TA;
                            }

                            that.SummaryArray = d.getWithdrawByYesterday;
                            that.Y_Withdraw = 0;
                            that.AMT_Y_Withdraw = 0;
                            var arrL = parseInt(that.SummaryArray.length);
                            var i = 0;
                            for (i = 0; i < arrL; i++) {
                                that.Y_Withdraw += that.SummaryArray[i].DC;
                                that.AMT_Y_Withdraw += that.SummaryArray[i].TA;
                            }

                            that.SummaryArray = d.getMemberBonusDataByDay;
                            that.AMT_D_Bonus = 0;
                            that.AMT_D_AR = 0;
                            that.AMT_D_DLS = 0;
                            that.AMT_D_Aff = 0;
                            that.AMT_D_TNMT = 0;
                            that.AMT_D_MSA = 0;
                            if (that.SummaryArray) {
                                var arrl = that.SummaryArray.length;
                                var i = 0;
                                for (i = 0; i < arrl; i++) {
                                    if (that.SummaryArray[i].TT == 1) {
                                        that.AMT_D_Bonus += that.SummaryArray[i].TBA;

                                    }
                                    else if (that.SummaryArray[i].TT == 2) {
                                        that.AMT_D_AR += that.SummaryArray[i].TBA;
                                    }
                                    else if (that.SummaryArray[i].TT == 3) {
                                        that.AMT_D_DLS += that.SummaryArray[i].TBA;
                                    }
                                    else if (that.SummaryArray[i].TT == 4) {
                                        that.AMT_D_Aff += that.SummaryArray[i].TBA;

                                    }
                                    else if (that.SummaryArray[i].TT == 5) {
                                        that.AMT_D_TNMT += that.SummaryArray[i].TBA;

                                    }
                                    else if (that.SummaryArray[i].TT == 6) {
                                        that.AMT_D_MSA += that.SummaryArray[i].TBA;
                                    }
                                }
                            }

                            that.SummaryArray = d.getMemberBonusDataByYesterday;
                            that.AMT_Y_Bonus = 0;
                            if (that.SummaryArray) {
                                var arrl = that.SummaryArray.length;
                                var i = 0;
                                for (i = 0; i < arrl; i++) {
                                    that.AMT_Y_Bonus += that.SummaryArray[i].TBA;
                                }
                            }

                            that.SummaryArray = d.getMemberBonusDataByMonth;
                            that.AMT_MTD_Bonus = 0;
                            that.AMT_MTD_AR = 0;
                            that.AMT_MTD_DLS = 0;
                            that.AMT_MTD_AFF = 0;
                            that.AMT_MTD_TNMT = 0;
                            that.AMT_MTD_MSA = 0;
                            if (that.SummaryArray) {
                                var arrl = that.SummaryArray.length;
                                var i = 0;
                                for (i = 0; i < arrl; i++) {
                                    if (that.SummaryArray[i].TT == 1) {
                                        that.AMT_MTD_Bonus += that.SummaryArray[i].TBA;
                                    }
                                    else if (that.SummaryArray[i].TT == 2) {
                                        that.AMT_MTD_AR += that.SummaryArray[i].TBA;
                                    }
                                    else if (that.SummaryArray[i].TT == 3) {
                                        that.AMT_MTD_DLS += that.SummaryArray[i].TBA;
                                    }
                                    else if (that.SummaryArray[i].TT == 4) {
                                        that.AMT_MTD_AFF += that.SummaryArray[i].TBA;
                                    }
                                    else if (that.SummaryArray[i].TT == 5) {
                                        that.AMT_MTD_TNMT += that.SummaryArray[i].TBA;
                                    }
                                    else if (that.SummaryArray[i].TT == 6) {
                                        that.AMT_MTD_MSA += that.SummaryArray[i].TBA;
                                    }
                                }
                            }

                            that.SummaryArray = d.getMemberBonusCappingDataByMonth;
                            that.AMT_MTD_BonusC = 0;
                            var arrl = parseInt(that.SummaryArray.length);
                            var i = 0;
                            for (i = 0; i < arrl; i++) {
                                that.AMT_MTD_BonusC += that.SummaryArray[i].TBA;
                            }

                            that.SummaryArray = d.getPNLDataByDay;
                            that.AMT_D_PNL = 0;
                            var arrL = parseInt(that.SummaryArray.length);
                            var i = 0;
                            for (i = 0; i < arrL; i++) {
                                that.AMT_D_PNL -= that.SummaryArray[i].WLA;
                            }

                            that.SummaryArray = d.getPNLDataByYesterday;
                            that.AMT_Y_PNL = 0;
                            var arrL = parseInt(that.SummaryArray.length);
                            var i = 0;
                            for (i = 0; i < arrL; i++) {
                                that.AMT_Y_PNL -= that.SummaryArray[i].WLA;
                            }

                            that.SummaryArray = d.getPNLDataByMonth;
                            that.AMT_MTD_PNL = 0;
                            var arrL = parseInt(that.SummaryArray.length);
                            var i = 0;
                            for (i = 0; i < arrL; i++) {
                                that.AMT_MTD_PNL -= that.SummaryArray[i].WLA;
                            }

                            that.SummaryArray = d.getPNLDataByLastMonth;
                            var arrL = parseInt(that.SummaryArray.length);
                            that.AMT_LMTD_PNL = 0;
                            var i = 0;
                            for (i = 0; i < arrL; i++) {
                                that.AMT_LMTD_PNL -= that.SummaryArray[i].WLA;
                            }

                            that.SummaryArray = d.getNPNLDataByLastMonth;
                            var arrL = parseInt(that.SummaryArray.length);
                            that.AMT_LMTD_NPNL = 0;
                            var i = 0;
                            for (i = 0; i < arrL; i++) {
                                that.AMT_LMTD_NPNL += that.SummaryArray[i].TBA;
                            }

                            // Total Downline and Member Earn
                            that.PNLDNM = d.getCurrentGGEarn;
                            // Total Earning Charts
                            //that.PNLSummaryArray1 = d.getPNLDataByMonthChart30.splice(0,1);
                            that.PNLSummaryArray7 = d.getPNLDataByMonthChart30.slice(23, 30);
                            that.PNLSummaryArray15 = d.getPNLDataByMonthChart30.slice(15, 30);
                            that.PNLSummaryArray30 = d.getPNLDataByMonthChart30.slice(0, 30);


                            //that.PNLSummaryArray3 = [
                            //        {
                            //                "CD": "20241112",
                            //                "CH": null,
                            //                "CI": null,
                            //                "CM": null,
                            //                "WLA": -222882.550732
                            //        },
                            //        {
                            //                "CD": "20241113",
                            //                "CH": null,
                            //                "CI": null,
                            //                "CM": null,
                            //                "WLA": -250420.473170
                            //        },
                            //        {
                            //                "CD": "20241114",
                            //                "CH": null,
                            //                "CI": null,
                            //                "CM": null,
                            //                "WLA": -217315.155806
                            //        },
                            //        {
                            //                "CD": "20241115",
                            //                "CH": null,
                            //                "CI": null,
                            //                "CM": null,
                            //                "WLA": -38550.795847
                            //        }
                            //    ];
                            //that.PNLSummaryArray7 = [
                            //        {
                            //                "CD": "20241108",
                            //                "CH": null,
                            //                "CI": null,
                            //                "CM": null,
                            //                "WLA": -370098.914561
                            //        },
                            //        {
                            //                "CD": "20241109",
                            //                "CH": null,
                            //                "CI": null,
                            //                "CM": null,
                            //                "WLA": -309903.393128
                            //        },
                            //        {
                            //                "CD": "20241110",
                            //                "CH": null,
                            //                "CI": null,
                            //                "CM": null,
                            //                "WLA": -118108.220480
                            //        },
                            //        {
                            //                "CD": "20241111",
                            //                "CH": null,
                            //                "CI": null,
                            //                "CM": null,
                            //                "WLA": -207130.999450
                            //        },
                            //        {
                            //                "CD": "20241112",
                            //                "CH": null,
                            //                "CI": null,
                            //                "CM": null,
                            //                "WLA": -222882.550732
                            //        },
                            //        {
                            //                "CD": "20241113",
                            //                "CH": null,
                            //                "CI": null,
                            //                "CM": null,
                            //                "WLA": -250420.473170
                            //        },
                            //        {
                            //                "CD": "20241114",
                            //                "CH": null,
                            //                "CI": null,
                            //                "CM": null,
                            //                "WLA": -217315.155806
                            //        },
                            //        {
                            //                "CD": "20241115",
                            //                "CH": null,
                            //                "CI": null,
                            //                "CM": null,
                            //                "WLA": -38550.795847
                            //        }
                            //    ];
                            //that.PNLSummaryArray15 = [
                            //        {
                            //                "CD": "20241031",
                            //                "CH": null,
                            //                "CI": null,
                            //                "CM": null,
                            //                "WLA": -236469.583813
                            //        },
                            //        {
                            //                "CD": "20241101",
                            //                "CH": null,
                            //                "CI": null,
                            //                "CM": null,
                            //                "WLA": -99728.417298
                            //        },
                            //        {
                            //                "CD": "20241102",
                            //                "CH": null,
                            //                "CI": null,
                            //                "CM": null,
                            //                "WLA": -158974.915539
                            //        },
                            //        {
                            //                "CD": "20241103",
                            //                "CH": null,
                            //                "CI": null,
                            //                "CM": null,
                            //                "WLA": -258021.846788
                            //        },
                            //        {
                            //                "CD": "20241104",
                            //                "CH": null,
                            //                "CI": null,
                            //                "CM": null,
                            //                "WLA": -301033.888462
                            //        },
                            //        {
                            //                "CD": "20241105",
                            //                "CH": null,
                            //                "CI": null,
                            //                "CM": null,
                            //                "WLA": -233124.017653
                            //        },
                            //        {
                            //                "CD": "20241106",
                            //                "CH": null,
                            //                "CI": null,
                            //                "CM": null,
                            //                "WLA": -319223.160469
                            //        },
                            //        {
                            //                "CD": "20241107",
                            //                "CH": null,
                            //                "CI": null,
                            //                "CM": null,
                            //                "WLA": -173341.856982
                            //        },
                            //        {
                            //                "CD": "20241108",
                            //                "CH": null,
                            //                "CI": null,
                            //                "CM": null,
                            //                "WLA": -370098.914561
                            //        },
                            //        {
                            //                "CD": "20241109",
                            //                "CH": null,
                            //                "CI": null,
                            //                "CM": null,
                            //                "WLA": -309903.393128
                            //        },
                            //        {
                            //                "CD": "20241110",
                            //                "CH": null,
                            //                "CI": null,
                            //                "CM": null,
                            //                "WLA": -118108.220480
                            //        },
                            //        {
                            //                "CD": "20241111",
                            //                "CH": null,
                            //                "CI": null,
                            //                "CM": null,
                            //                "WLA": -207130.999450
                            //        },
                            //        {
                            //                "CD": "20241112",
                            //                "CH": null,
                            //                "CI": null,
                            //                "CM": null,
                            //                "WLA": -222882.550732
                            //        },
                            //        {
                            //                "CD": "20241113",
                            //                "CH": null,
                            //                "CI": null,
                            //                "CM": null,
                            //                "WLA": -250420.473170
                            //        },
                            //        {
                            //                "CD": "20241114",
                            //                "CH": null,
                            //                "CI": null,
                            //                "CM": null,
                            //                "WLA": -217315.155806
                            //        },
                            //        {
                            //                "CD": "20241115",
                            //                "CH": null,
                            //                "CI": null,
                            //                "CM": null,
                            //                "WLA": -38550.795847
                            //        }
                            //    ];
                            //that.PNLSummaryArray30 = d.getPNLDataByMonthChart30;


                            that.showChartDuration(that.chartActiveDuration)

                            //that.SummaryArray = d.getMemberDepositDataByMonthChartS;

                            //that.CD_Deposit = [];
                            //that.CD_DepositMoney = [];
                            //var arrL = parseInt(that.SummaryArray.length);
                            //var i = 0;
                            //for (i = 0; i < arrL; i++) {
                            //    //that.CD_Deposit.push(that.SummaryArray[i].DC + '-' + that.SummaryArray[i].TA);
                            //    that.CD_Deposit.push(that.SummaryArray[i].DC);

                            //    that.CD_DepositMoney.push(that.SummaryArray[i].TA);
                            //}
                            ////The name at the bottom of the chart (Deposit - Count)
                            //var temp = {
                            //    name: that.getLanguage['DB']['D'],
                            //    data: that.CD_Deposit,
                            //}

                            //var temp1 = {
                            //    name: "Deposit-Money",
                            //    data: that.CD_DepositMoney,
                            //    decimalPoint: that.CheckIsThousandCurrency(that.CurrencySymbol) ? 3 : 2,
                            //}

                            //Vue.set(that.series, 0, temp)
                            //Vue.set(that.chartOptions.savedata, 0, temp1)
                            //that.showChartDuration(that.chartActiveDuration)
                            /////

                            that.SummaryArray = d.getMemberDepositDataByMonth;
                            that.MTD_Deposit = 0;
                            that.AMT_MTD_Deposit = 0;
                            var arrL = parseInt(that.SummaryArray.length);
                            var i = 0;
                            for (i = 0; i < arrL; i++) {
                                that.MTD_Deposit += that.SummaryArray[i].DC;
                                that.AMT_MTD_Deposit += that.SummaryArray[i].TA;
                            }

                            that.SummaryArray = d.getMemberWithdrawDataByMonth;
                            that.MTD_Withdraw = 0;
                            that.AMT_MTD_Withdraw = 0;
                            var arrL = parseInt(that.SummaryArray.length);
                            var i = 0;
                            for (i = 0; i < arrL; i++) {
                                that.MTD_Withdraw += that.SummaryArray[i].DC;
                                that.AMT_MTD_Withdraw += that.SummaryArray[i].TA;
                            }

                            that.SummaryArray = d.getMemberDepositDataByLastMonth;
                            that.L_MTD_Deposit = 0;
                            that.AMT_LMTD_Deposit = 0;
                            that.CD_Deposit = [];
                            var arrL = parseInt(that.SummaryArray.length);
                            var i = 0;
                            for (i = 0; i < arrL; i++) {
                                that.CD_Deposit.push(that.SummaryArray[i].DC);
                                that.L_MTD_Deposit += that.SummaryArray[i].DC;
                                that.AMT_LMTD_Deposit += that.SummaryArray[i].TA;
                            }

                            that.SummaryArray = d.getMemberWithdrawDataByLastMonth;
                            that.L_MTD_Withdraw = 0;
                            that.AMT_LMTD_Withdraw = 0;
                            var arrL = parseInt(that.SummaryArray.length);
                            var i = 0;
                            for (i = 0; i < arrL; i++) {
                                that.L_MTD_Withdraw += that.SummaryArray[i].DC;
                                that.AMT_LMTD_Withdraw += that.SummaryArray[i].TA;
                            }
                            that.alreadyLoad = true;


                            if (that.PNLDNM && sessionStorage.getItem('showBalance') === 'true') {
                                that.isVisibleBalance = true;
                            }
                        }
                        that.bool_fullLoading = false;
                    });
            },
            getDateInfo() {
                var that = this;

                this.DB_Month = moment().format('MMMM');
                this.DB_TDay = moment().endOf('month').format('DD');
                this.DB_CDay = moment().format('DD');
                this.DB_DProgress = ((this.DB_CDay * 100) / this.DB_TDay).toFixed(2);
                this.getDataApi(`/api/dc/drdt`,
                    function (d, s) {
                        if (s) {
                            that.DB_DRefresh = moment(d).format("MMM DD, YYYY hh:mm a");
                        }
                    });
            },
            getConvertCurrencyList() {
                var that = this;
                this.getDataApi(`/api/dd/cur/0`,
                    function (d, s) {
                        if (s) {
                            that.dd_currency1 = d.dropdownlist;
                            if (that.dd_currency1.length > 0) {
                                var at = 0;
                                at = that.getUserInfo.AT;
                                if ((that.searchAgent == null && that.bool_firstLogin == false) || (at == 0 && that.bool_firstLogin == false) || (at == 1 && that.bool_firstLogin == false) || (at == 2 && that.bool_firstLogin == false)) {
                                    if (localStorage.getItem('CCUSD') != "") {
                                        for (var i = 0; i < that.dd_currency1.length; i++) {
                                            if (that.dd_currency1[i].id == localStorage.getItem('CCUSD')) {
                                                that.convertCurrency = that.dd_currency1[i].id;
                                                break;
                                            }
                                        }
                                    }
                                    if (that.convertCurrency == null) {
                                        that.convertCurrency = that.dd_currency1[0].id;
                                    }
                                    that.bool_firstLogin = true;
                                }
                            }
                            if (that.searchAgent != null && that.searchCurrency != null && that.bool_firstsearchAgent == false) {
                                that.convertCurrency = null;
                                that.bool_firstsearchAgent = true;
                            }
                            that.AutoUpdate();
                            that.AutoGetUpdate(true, true, true);
                        }
                    });
            },
            getCurrencyList() {
                var that = this;
                var agi = 0;

                if (this.searchPAgi) {
                    agi = this.searchPAgi;
                }
                this.getDataApi(`/api/dd/currency/${agi}`,
                    function (d, s) {
                        if (s) {
                            that.dd_currency = d.dropdownlist;
                        }
                    });
            },
            changeCurrency(array_C, cC, sC) {
                if (!this.alreadyLoad) {
                    return this.prevCurrencyCode;
                }
                var z = "";
                for (var i = 0; i < array_C.length; i++) {
                    if (cC == array_C[i].id && cC != null) {
                        z = array_C[i].label;
                        break;
                    }
                    else if (sC == array_C[i].id && sC != null) {
                        z = array_C[i].label;
                    }
                }
                this.prevCurrencyCode = z;
                return z;
            },
         
            AutoUpdate() {
                var that = this;
                //this.AutoUpdateTO = setTimeout(function () {
                //    that.AutoUpdate();
                //}, 10000);
            },
            AutoGetUpdate(isHideCount = false, isHideAmount = false, isLoading = false) {
                this.nextGetUpdate(isHideCount, isHideAmount, isLoading);
                var that = this;
                //this.AutoGetUpdateTO = setTimeout(function () {
                //    that.AutoGetUpdate();
                //}, 60000);
            },
            nextGetUpdate: function (isHideCount = false, isHideAmount = false, isLoading = false) {
                var CTCI = this.convertCurrency;
                var CC = this.getCurrencyCode;
                if (this.convertCurrency == null) {
                    localStorage.setItem('CCUSD', "");
                    for (var i = 0; i < this.dd_currency1.length; i++) {
                        if (this.dd_currency1[i].label == CC) {
                            CTCI = this.dd_currency1[i].id;
                            break;
                        }
                    }
                    localStorage.setItem('CCUSD', CTCI);
                }
                else {
                    localStorage.setItem('CCUSD', this.convertCurrency);
                }


                if (isLoading) {
                    this.bool_fullLoading = true;
                }
                this.getDateInfo();
                if (!this.bool_ajaxloading.dashboardDataList) {
                    this.getdashboardData(isHideCount, isHideAmount);
                }
                //this.nextUpdate(isLoading);
            },
       
            showChartDuration(days) {
                setTimeout(() => {
                    this.chartActiveDuration = days;
                    this.CD_Earning = [];
                    var noLabelShow = 0;
                    switch (days) {
                        default:
                        case 3:                     
                            this.$refs.apexchart.zoomX(1, 3)
                            this.SummaryArray = this.PNLSummaryArray3;
                            noLabelShow = 1;
                            break;
                        case 7:
                            this.$refs.apexchart.zoomX(1, 7)
                            this.SummaryArray = this.PNLSummaryArray7;
                            noLabelShow = 2;
                            break;
                        case 15:
                            this.$refs.apexchart.zoomX(1, 15)
                            this.SummaryArray = this.PNLSummaryArray15;
                            noLabelShow = 4;
                            
                            break;
                        case 30:
                            this.$refs.apexchart.zoomX(1, 30)
                            this.SummaryArray = this.PNLSummaryArray30;
                            noLabelShow = 7;
                            break;
                    }


                    var arrL = parseInt(this.SummaryArray.length);
                    var i = 0;
                    for (i = 0; i < arrL; i++) {
                        this.CD_Earning.push(parseFloat(this.SummaryArray[i].WLA).toFixed(this.CheckIsThousandCurrency(this.getCurrencySymbol) ? 3 : 2));
                    }
                    //The name at the bottom of the chart (Total Earning)
                    var temp = {
                        name: this.getLanguage['DB']['TEN'],
                        data: this.CD_Earning,
                    }


                    var dateRange = [];
                    for (var i = days; i >= 0; i--) {
                        var date = new Date();
                        date.setDate(date.getDate() - i);
                        var dd = String(date.getDate()).padStart(2, '0');
                        var mm = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
                        dateRange.push(dd + '/' + mm);
                    }

                    Vue.set(this.series, 0, temp);
                    this.chartOptions = {
                        ...this.chartOptions, ...{
                            xaxis: {
                                categories: dateRange,
                                labels: {
                                    formatter: function (value) {
                                        const index = dateRange.indexOf(value);
                                        if (index % noLabelShow === 0) {
                                            return value;
                                        }
                                        return ''; 
                                    },
                                },
                            }
                        }
                    }
                }, 100)
            },
            handleTouchStart(event) {
                this.startX = event.touches[0].clientX;
                this.startTime = Date.now(); // Record the start time
                this.isSwiping = false; // Reset swiping status
            },
            handleTouchMove(event) {
                this.endX = event.touches[0].clientX;

                // Determine if the user is swiping based on distance
                const distanceX = this.endX - this.startX;
                if (Math.abs(distanceX) > this.threshold) {
                    this.isSwiping = true; // Set swiping status to true if the swipe distance exceeds the threshold
                }
            },
            handleTouchEnd() {
                const distanceX = this.endX - this.startX;
                const elapsedTime = Date.now() - this.startTime;

                // Check if the swipe is valid
                if (this.isSwiping && elapsedTime < this.timeThreshold) {
                    // Only execute swipe actions if it's a valid swipe
                    if (distanceX > 0) {
                        this.nextSlide();
                    } else {
                        this.prevSlide();
                    }
                } else if (!this.isSwiping) {
                    // Treat it as a click if not swiping
                }

            },
            nextSlide() {
                this.currentSlide =
                    (this.currentSlide + 1) % 2;
            },
            prevSlide() {
                this.currentSlide =
                    (this.currentSlide - 1 + 2) %
                    2;
            },

            getProfile() {
                this.bool_fullLoading = true;
                var that = this;
                this.getDataApi(`/api/agt/g/0`, function (d, s) {
                    that.bool_fullLoading = false;
                    if (s) {
                        that.setProfileData(d.D);
                    }
                });
            },
            setProfileData(data) {
                var agi;
                this.obj_P = data;
                this.obj_P.UP = '';

                agi = (this.obj_P.AT == 4) ? this.obj_P.SAGAGI : this.obj_P.AGI;
                this.obj_P.ATAGI = this.obj_P.AT + "-" + agi;

                if (this.obj_P.IFL) {
                    this.showFirstTimeRemind = true;
                }
            },
        },

        beforeRouteLeave(to, from, next) {
            clearTimeout(this.AutoUpdateTO);
            clearTimeout(this.AutoGetUpdateTO);
            next();
        },
        created() {
            this.fromCache = this.$route.query.c;
            this.$parent.showSubMenu = 'DASH';
            this.$parent.showActiveMenu = 'DASH.DBM';
            this.View_acce = this.checkModuleAccess('DBM', 'DASH', constAccessType.view);
            this.View_acce2 = this.checkModuleAccess('DMMAL', 'DASH', constAccessType.view);
        },
        mounted() {
            this.getDateInfo();
            this.getAgentGroup();
            this.getCurrencyList();
            this.getConvertCurrencyList();
            //this.getProfile()
            if (this.getUserInfo.AT == 4) {
                this.loadDefaultSubBrand(0);
            }
        },
        watch: {
            getLanguage() {
                //this.getUserActivityList();
                this.getCurrencyList();
               /* this.getLang()*/;

            },
            convertCurrency(newValue, oldValue) {
                if (newValue != oldValue) {
                    this.alreadyLoad = false;
                }
            },
            searchCurrency(newValue, oldValue) {
                if (newValue != oldValue) {
                    this.alreadyLoad = false;
                }
            },
            isVisibleBalance(newValue, oldValue) {
                if (newValue != oldValue) {
                    sessionStorage.setItem('showBalance', newValue);
                }
            },
        }
    }

</script>

<style scoped>
    /*h6.title-db, h5.title-db {
        height: 30px;
    }*/

    .plus-button {
        border: 2px solid #a3a3a3;
        background-color: #a3a3a3;
        font-size: 16px;
        height: 2em;
        width: 2em;
        border-radius: 999px;
        position: relative;
        float: right;
    }

        .plus-button:after, .plus-button:before {
            content: "";
            display: block;
            background-color: white;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }

        .plus-button:before {
            height: 1em;
            width: 0.2em;
        }

        .plus-button:after {
            height: 0.2em;
            width: 1em;
        }

    .plus-button--small {
        font-size: 12px;
    }

    .theme-cicle-title {
        display: flex;
        align-items: center;
    }

    .text-grey {
        color: #808080;
    }

    /*.text-top3 {
        color: #2C772C;
    }

    .text-bottom3 {
        color: rgb(229, 54, 54) !important;
    }*/

    .apexcharts-text tspan {
        font-weight: 700;
    }

    .durationActive {
        padding: 5px;
        border-radius: 5px;
        color: #fff;
        font-weight: bold;
        background: #31333f;
        font-size: 12px;
        border: solid 1px #ffa700 !important;
    }

    .durationNoActive {
        background: #31333f;
        padding: 5px;
        border-radius: 5px;
        color: rgb(128, 132, 136);
        font-size: 12px;
    }

   /* .apexcharts-grid, apexcharts-yaxis {
        display: none;
    }

    .apexcharts-grid-borders {
        display: none;
        border-bottom: 1px solid #fff;
    }*/

   /* .apexcharts-tooltip {
        color: #000;
    }*/

    .day-list .pointer {
        margin-inline: 3px;
    }

    .mark-down, .mark-up {
        margin-bottom: .5rem;
        font-weight: 600 !important;
    }

    .mark-up {
        background: rgba(36, 145, 41, 1);
        color: #fff !important;
    }

    .mark-down {
        background: rgba(193, 12, 12, 1);
    }

    body.marketingApp .registered-member, body.marketingApp .deposit-member, body.marketingApp .member-online, body.marketingApp .total-member {
        background: rgba(36, 38, 43, 1) !important;
    }

    .member-online .theme-value, .deposit-member .theme-value, .total-member .theme-value, .registered-member .theme-value {
        font-size: 20px !important;
        font-weight: 700 !important;
    }

    svg.apexcharts-svg {
        border-radius: 15px !important;
    }

    /* Container for the icon */
    .icon-container {
        display: inline-block;
        position: relative;
    }

    /* Icon styling */
    .icon-container i {
        font-size: 50px; /* Adjust size as needed */
        color: #fff; /* Danger color */
        animation: grow-shake 3s ease-in-out infinite; /* Animation every 2 seconds */
    }

    /* Combined grow and shake animation */
    @keyframes grow-shake {
        0%, 100% {
            transform: scale(1) translateX(0); /* Normal state */
        }

        25% {
            transform: scale(1.2); /* Grow and shake left */
            filter: drop-shadow(0 0 4px rgba(255, 0, 0, 0.8)); /* Drop shadow effect */
            color: #ff0000;
        }

        50% {
            transform: scale(1.2); /* Grow and shake right */
            filter: drop-shadow(0 0 8px rgba(255, 0, 0, 0.8)); /* Drop shadow effect */
            color: #ff0000;
        }

        75% {
            transform: scale(1.2); /* Subtle shake left */
            filter: drop-shadow(0 0 10px rgba(255, 0, 0, 0.8)); /* Drop shadow effect */
            color: #ff0000;
        }
    }


    i.fa-up-right-and-down-left-from-center {
        color: white;
        position: absolute;
        bottom: 10px;
        right: 10px;
        animation: pulses 1.5s infinite; 
    }
    @keyframes pulses {
        0% {
            transform: scale(1);
        }

        50% {
            transform: scale(1.2);
        }

        100% {
            transform: scale(1);
        }
    }
</style>



// WEBPACK FOOTER //
// src/componentsGGEarn/DashboardMonitoring.vue